import { action } from 'mobx';
import moment from 'moment';
import _ from 'lodash';
import { TableViewStore, BaseListViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import { CoreUserService } from 'application/user/services';
import { ModalParams } from 'core/models';
import { TeamsService } from "application/teams/services";
@applicationContext
class UserViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const coreUserService = new CoreUserService(rootStore.application.baasic.apiClient);
        const teamsService = new TeamsService(
                    rootStore.application.baasic.apiClient
                );
        super(rootStore, {
            name: 'user',
            autoInit: false,
            authorization: {
                create: 'coreUserSection.create',
                update: 'coreUserSection.update',
                delete: 'coreUserSection.delete',
            },
            routes: {
                edit: id =>{
                    this.setChildNavigationTitle(i => i.id === id, item => item.userName);
                    this.rootStore.routerStore.goTo(
                        'master.app.main.user.edit',
                        { id: id }
                    );
                },
                preview: id =>{
                    this.setChildNavigationTitle(i => i.id === id, item => item.userName);
                    this.rootStore.routerStore.goTo(
                        'master.app.main.user.preview',
                        { id: id }
                    );
                },
                create: () =>
                    this.rootStore.routerStore.goTo(
                        'master.app.main.user.create'
                    )
            },
            actions: () => {
                const service = rootStore.application.baasic.membershipModule.user;
               
                return {
                    find: async (params) => {
                        const response = await coreUserService.find(_.extend(params, {
							embed: 'CoreMembership,UserSetting',
						}));

                        const responseData = _.extend(response.data, {
							item: _.map(response.data.item, (item => {
								return _.extend(
									item, {
										lastLoginDate: item.coreMembership.lastLoginDate,
                                        email: item.coreMembership.email,
                                        isApproved: item.coreMembership.isApproved,
                                        isLockedOut: item.coreMembership.isLockedOut,
									}
								);
							}))
						});				

                        this.mapData(responseData);
                        return responseData;
                    },
                    delete: service.delete
                }
            }
            
        });

        this.teamsService = teamsService;
        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: [
                {
                    key: 'firstName',
                    title: 'USER.LIST.COLUMNS.FIRST_NAME',
                    onClick: item => this.routes.preview(item.id),
                    authorization: this.authorization.read
                },
                {
                    key: 'lastName',
                    title: 'USER.LIST.COLUMNS.LAST_NAME',
                    onClick: item => this.routes.preview(item.id),
                    authorization: this.authorization.read
                },
                {
                    key: 'email',
                    title: 'USER.LIST.COLUMNS.EMAIL',
                    onClick: item => this.routes.preview(item.id),
                    authorization: this.authorization.read
                },
                {
                    key: 'lastLoginDate',
                    title: 'USER.LIST.COLUMNS.LAST_LOGIN',
                    onClick: item => this.routes.preview(item.id),
                    authorization: this.authorization.read
                }
            ],
            actions: {
                onEmailSignatureEdit: (user) => this.emailSignatureEdit(user),
                onEdit: (user) => this.routes.edit(user.id),
                onPreview: (user) => this.routes.preview(user.id),
                onLock: (user) => this.lockUser(user),
                onUnlock: (user) => this.unlockUser(user),
                onApprove: (user) => this.approveUser(user),
                onDisapprove: (user) => this.disapproveUser(user),
                onSort: (column) => this.queryUtility.changeOrder(column.key),
                actionsWidth: 190
            }
        }));

        this.emailSignatureEditModal = new ModalParams({
            onClose: () => {
                this.queryUtility.fetch();   
            }
        });
    }

    mapData(data){
        _.map(data.item, function(item){
            //TODO. removenoOfBuildings after implementation
            // item.noOfBuildings = null;

            item.lastLoginDate = moment(item.lastLoginDate).format("MM/DD/YYYY");
            if (item.lastLoginDate === '01/01/1754'){
                item.lastLoginDate = null;
            }
        });
    }

    @action.bound
    async onInit() {
        await this.queryUtility.initialize();
    }

    @action.bound
    async deleteUser(user) {
        this.loaderStore.suspend();
        await this.rootStore.application.baasic.membershipModule.user.delete(user);
        await this.queryUtility.fetch();
        this.loaderStore.resume();
    }

    @action.bound
    async lockUser(user) {
        this.loaderStore.suspend();
        await this.rootStore.application.baasic.membershipModule.user.lock(user);
        this.rootStore.notificationStore.success('User successfully locked.');
        await this.queryUtility.fetch();
        this.loaderStore.resume();
    }

    @action.bound
    async unlockUser(user) {
        this.loaderStore.suspend();
        await this.rootStore.application.baasic.membershipModule.user.unlock(user);
        this.rootStore.notificationStore.success('User successfully unlocked.');
        await this.queryUtility.fetch();
        this.loaderStore.resume();
    }

    @action.bound
    async approveUser(user) {
        this.loaderStore.suspend();
        await this.rootStore.application.baasic.membershipModule.user.approve(user);
        this.rootStore.notificationStore.success('User successfully approved.');
        await this.queryUtility.fetch();
        this.loaderStore.resume();
    }

    @action.bound
    async disapproveUser(user) {
        this.loaderStore.suspend();
        await this.rootStore.application.baasic.membershipModule.user.disapprove(user);
        this.rootStore.notificationStore.success('User successfully disapproved.');
        await this.queryUtility.fetch();
        await this.teamsService.deleteTeamUsers({userId: user.id});
        this.loaderStore.resume();
    }

    @action.bound
    async emailSignatureEdit(user) {
        this.emailSignatureEditModal.open({
            userId: user.id,
            userSetting: user.userSetting
        });
    }
}

export default UserViewStore;
